const first = (...values: any[]) => values.find(value => value !== undefined && value !== null && value !== "");

const objectValue = (value: any) => value && typeof value === "object" && !Array.isArray(value) ? value : {};

export const normalizeActivityLogRow = (row: Record<string, any>) => {
  const metadata = objectValue(row.metadata);
  const details = objectValue(metadata.details);
  const request = objectValue(first(metadata.request, details.requestMetadata));
  const normalized: Record<string, any> = {};
  const set = (key: string, ...values: any[]) => {
    const value = first(...values);
    if (value !== undefined) normalized[key] = value;
  };

  set("_id", row._id, row.id, row.eventId, row.event_id);
  set("eventId", row.eventId, row.event_id, row._id);
  set("schemaVersion", row.schemaVersion, row.schema_version);
  const actorId = first(row.actorId, row.actor_id);
  const userId = first(row.userId, row.subjectId, row.subject_id);

  set("email", row.email, row.actorEmail, metadata.actor_email, metadata.actorEmail);
  // A self-service event has the same actor and subject. Showing both values
  // creates two identical "Actor ID" / "User ID" columns, so actorId is kept
  // only when it identifies a distinct administrator or service actor.
  if (actorId !== undefined && String(actorId) !== String(userId ?? "")) {
    set("actorId", actorId);
  }
  set("actorType", row.actorType, row.actor_type);
  set("subjectEmail", row.subjectEmail, row.subject_email, metadata.subject_email, metadata.subjectEmail);
  set("userId", userId);
  set("action", row.action, row.eventType, row.event_type, row.activityType);
  set("service", row.service, row.serviceName, row.service_name);
  set("resource", row.resource, row.entityType, row.entity_type);
  set("entityId", row.entityId, row.entity_id);
  set("appId", row.appId, row.applicationId, row.application_id);
  set("appObjectId", row.appObjectId, row.entityId, row.entity_id, metadata.app_object_id, details.appObjectId);
  set("createdAt", row.createdAt, row.created_at, row.timestamp);
  set("applicationProtocol", row.applicationProtocol, request.applicationProtocol, request.application_protocol);
  set("browser", row.browser, request.browser);
  set("deviceDetails", row.deviceDetails, request.deviceDetails, request.device_details);
  set("deviceType", row.deviceType, request.deviceType, request.device_type);
  set("ipAddress", row.ipAddress, request.ipAddress, request.ip_address);
  set("location", row.location, request.location);
  set("operatingSystem", row.operatingSystem, request.operatingSystem, request.operating_system);
  set("performedBy", row.performedBy, row.actorType, row.actor_type);
  set("protocolType", row.protocolType, request.protocolType, request.protocol_type);
  set("sessionDuration", row.sessionDuration, metadata.session_duration);
  set("changes", row.changes);
  set("metadata", row.metadata);
  set("traceId", row.traceId, row.trace_id);
  set("kafkaTopic", row.kafkaTopic, row.kafka_topic);
  set("kafkaPartition", row.kafkaPartition, row.kafka_partition);
  set("kafkaOffset", row.kafkaOffset, row.kafka_offset);
  set("chainId", row.chainId, row.chain_id);
  set("hashVersion", row.hashVersion, row.hash_version);
  set("prevHash", row.prevHash, row.prev_hash);
  set("hash", row.hash);
  return normalized;
};

export const normalizeActivityLogRows = (rows: Array<Record<string, any>>) => rows.map(normalizeActivityLogRow);
